import { throwError } from "@/lib/throwError";
import { get, post } from "@/services/axiosUitils";

class UploadService {
  uploadFiles = async ({
    folderName,
    files,
  }: {
    folderName: string;
    files: File[];
  }): Promise<any> => {
    if (!folderName || !files) {
      throwError("Folder name and files are required", "UploadService");
    }
    const formData = new FormData();
    formData.append("folder_name", folderName);

    files.forEach(file => {
      formData.append("file_path", file);
    });

    return await post("/api/file-utility/files/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  getFileById = async ({ id }: { id: string }): Promise<any> => {
    return await get(`/api/file-utility/files/${id}/`);
  };
}

export default new UploadService();
